import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  IdDiarioObrasAtividades: number;
  IdDiarioObras: number;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};

export const initialFiltersValues: State = {
  IdDiarioObrasAtividades: 0,
  IdDiarioObras: 0,
};

export const useDiarioObrasAtividadesFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));